module.exports = __webpack_public_path__ + "src/images/indesign-logo.fad32d1e94213b2d454216e969957f17.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/indesign-logo.png
// module id = 101
// module chunks = 0